if (!customElements.get('cart-progress-bar')) { 
  class CartProgressBarElement extends HTMLElement {
    constructor() {
      super();
      this.milestones = [];
      this.cartSubtotal = 0;
      // DOM refs
      this._barFill = null;
      this._milestoneEls = [];
    }

    static get observedAttributes() {
      return ['cart-subtotal'];
    }

    connectedCallback() {
      this._parseMilestones();
      this._parseCartSubtotal();
      this._cacheDom();
      this._bannerListeners();
      this._getBannerPosition();
      this._cartUpdateHandler = this._handleCartUpdate.bind(this);
      document.addEventListener('cart:update', this._cartUpdateHandler);
    }

    disconnectedCallback() {
      if (this._cartUpdateHandler) {
        document.removeEventListener('cart:update', this._cartUpdateHandler);
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'cart-subtotal' && oldValue !== newValue) {
        this.cartSubtotal = parseFloat(newValue) || 0;
        this._updateState();
      }
    }

    async refreshCartProgressBar() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        if (cart && cart.total_price !== undefined) {
          this.cartSubtotal = cart.total_price / 100;
        }
      } catch (error) {
        console.error('Error fetching cart data:', error);
      }
      this._updateState();
    }

    setCartSubtotal(newSubtotal) {
      this.setAttribute('cart-subtotal', newSubtotal);
    }

    async _handleCartUpdate(event) {
      const cartData = event.detail?.cartData;
      let newSubtotal = 0;
      if (cartData && cartData.total_price !== undefined) {
        newSubtotal = cartData.total_price / 100;
      } else {
        await fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            if (cart && cart.total_price !== undefined) {
              newSubtotal = cart.total_price / 100;
            }
          })
          .catch((error) => {
            console.error('Error fetching cart data:', error);
          });
      }
      this.setCartSubtotal(newSubtotal);
    }

    _parseMilestones() {
      const script = this.querySelector('script[type="application/json"].cart-progress-milestones-json');
      if (script) {
        try {
          this.milestones = JSON.parse(script.textContent.trim() || '[]');
          this.maxSubtotal = this.milestones.length ? this.milestones[this.milestones.length - 1].cost : 1;
        } catch (e) {
          this.milestones = [];
          this.maxSubtotal = 1;
        }
      }
    }

    _parseCartSubtotal() {
      this.cartSubtotal = parseFloat(this.getAttribute('cart-subtotal')) || 0;
    }

    _cacheDom() {
      const root = this.querySelector('.cart-progress');
      if (!root) return;
      this._barFill = root.querySelector('[data-cart-progress-bar-fill]');
      this._milestoneEls = Array.from(root.querySelectorAll('[data-cart-progress-milestone]'));
    }

    _getMilestoneStatus(index) {
      const milestone = this.milestones[index];
      if (this.cartSubtotal >= milestone.cost) {
        if (
          index === this.milestones.length - 1 ||
          this.cartSubtotal < this.milestones[index + 1].cost
        ) {
          return 'active';
        }
        return 'achieved';
      }
      return 'upcoming';
    }

    _getProgressPercent() {
      if (!this.milestones.length || !this.maxSubtotal) return 0;
      let percent = (this.cartSubtotal / this.maxSubtotal) * 100;
      return Math.max(0, Math.min(100, percent));
    }

    _updateState() {
      // Update bar fill
      const bannerTarget = this.querySelector('[data-banner-target]');
      const textEl = bannerTarget.querySelector('.cart-progress-banner__text, [data-banner-text]');
      const bannerText = textEl.textContent;
      
      

      const progressPercent = this._getProgressPercent();

      // Actualizar la barra de progreso
      if (this._barFill) {
        // Mostrar/ocultar banner solo si no ha sido interactuado
        if (bannerTarget && !bannerTarget.classList.contains('was-clicked')) {
          if(progressPercent > 0 ){
            bannerTarget.classList.add('hidden');
          }else if(bannerText.trim() !== ''){
            bannerTarget.classList.remove('hidden');
          }
        }

        const percent = progressPercent + '%';
        if (this._barFill.style.width !== percent) {
          this._barFill.style.width = percent;
        }
      }
      // Update milestone classes
      this._milestoneEls.forEach((el, i) => {
        const status = this._getMilestoneStatus(i);
        if (!el.classList.contains(`cart-progress__milestone--${status}`)) {
          el.classList.remove('cart-progress__milestone--achieved', 'cart-progress__milestone--active', 'cart-progress__milestone--upcoming');
          el.classList.add(`cart-progress__milestone--${status}`);

          // new classes
          el.classList.remove('is-achieved', 'is-active', 'is-upcoming');
          el.classList.add(`is-${status}`);
        }
        // Update checkmark SVG
        const dot = el.querySelector('[data-cart-progress-milestone-dot]');
        if (dot) {
          if ((status === 'achieved' || status === 'active') && !dot.querySelector('svg')) {
            dot.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="8" fill="none"/><path d="M4 8.5L7 11.5L12 5.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          } else if (!(status === 'achieved' || status === 'active') && dot.innerHTML !== '') {
            dot.innerHTML = '';
          }
        }
      });
    }

    /**
     * Agrega listeners a los elementos que disparan o cierran el banner.
     */
    _bannerListeners() {
      this.querySelectorAll('[data-banner]').forEach(el =>
        el.addEventListener('click', () => this._showBanner(el))
      );

      this.querySelectorAll('[data-banner-close]').forEach(el =>
        el.addEventListener('click', () => this._closeBanner(el))
      );
    }

    /**
     * Muestra el banner con la imagen y el texto proporcionado por el atributo data-banner del elemento clicado.
     * @param {Element} el - Elemento que contiene el atributo data-banner con la información del banner.
     */

    _getBannerPosition(el) {
      const bannerData = JSON.parse(this.querySelector('[data-banner]').getAttribute('data-banner'));
      const bannerTarget = this.querySelector('[data-banner-target]');

      let arrowPosition = bannerData.position + '%'
       // prevenir mostrar la flecha del banner fuera de la zona del banner
       if (bannerData.position === 100) {
        arrowPosition = 'calc(100% - 20px)'
      } else {
        arrowPosition = bannerData.position + '%'
      }

      bannerTarget.style = `--banner-arrow-position: ${arrowPosition};`
    }

    _showBanner(el) {
      const bannerData = JSON.parse(el.getAttribute('data-banner'));
      const bannerTarget = this.querySelector('[data-banner-target]');
      const imgEl = bannerTarget.querySelector('.cart-progress-banner__image, [data-banner-image]');
      const textEl = bannerTarget.querySelector('.cart-progress-banner__text, [data-banner-text]');

      if(bannerData.text === '' || bannerData.text === null || bannerData.text === undefined) return;

      // Extraer el src y alt de la etiqueta <img> contenida en bannerData.image
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = bannerData.image;
      const imgTag = tempDiv.querySelector('img');

      let arrowPosition = bannerData.position + '%'

      // prevenir mostrar la flecha del banner fuera de la zona del banner
      if (bannerData.position === 100) {
        arrowPosition = 'calc(100% - 20px)'
      } else {
        arrowPosition = bannerData.position + '%'
      }

      bannerTarget.style = `--banner-arrow-position: ${arrowPosition};`

      if (imgTag && imgEl) {
        imgEl.src = imgTag.src || '';
        imgEl.alt = imgTag.alt || '';
        imgEl.style.display = 'block'; // Asegura que se muestre si estaba oculto
      }

      if (textEl) {
        textEl.innerHTML = bannerData.text || '';
      }

      bannerTarget?.classList.remove('hidden');
      bannerTarget?.classList.add('was-clicked');
    }

    /**
     * Oculta el banner.
     */
    _closeBanner(el) {
      const bannerTarget = el.closest('[data-banner-target]');
      bannerTarget?.classList.add('hidden');
      bannerTarget?.classList.remove('was-clicked');
    }

  }

  customElements.define('cart-progress-bar', CartProgressBarElement);
}

